"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplaySchedule = exports.DaySchedule = exports.TimeSlot = void 0;
const swagger_1 = require("@nestjs/swagger");
/**
 * Time slot configuration for a specific time range
 */
class TimeSlot {
    from;
    to;
}
exports.TimeSlot = TimeSlot;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Start time in seconds from midnight (0-86400)",
        example: 28800,
        minimum: 0,
        maximum: 86400,
    }),
    __metadata("design:type", Number)
], TimeSlot.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "End time in seconds from midnight (0-86400)",
        example: 64800,
        minimum: 0,
        maximum: 86400,
    }),
    __metadata("design:type", Number)
], TimeSlot.prototype, "to", void 0);
/**
 * Daily schedule configuration for a display
 */
class DaySchedule {
    isOperative;
    timetable;
}
exports.DaySchedule = DaySchedule;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is operative on this day",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DaySchedule.prototype, "isOperative", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of time slots when the display is active",
        type: [TimeSlot],
        example: [
            { from: 28800, to: 43200 }, // 8:00 AM to 12:00 PM
            { from: 46800, to: 64800 }, // 1:00 PM to 6:00 PM
        ],
    }),
    __metadata("design:type", Array)
], DaySchedule.prototype, "timetable", void 0);
/**
 * Weekly schedule configuration for display operation times
 * Defines when a display is active throughout the week
 */
class DisplaySchedule {
    mon;
    tue;
    wed;
    thu;
    fri;
    sat;
    sun;
}
exports.DisplaySchedule = DisplaySchedule;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Monday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800 }],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "mon", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Tuesday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800 }],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "tue", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Wednesday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800 }],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "wed", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Thursday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800 }],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "thu", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Friday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: true,
            timetable: [{ from: 28800, to: 64800 }],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "fri", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Saturday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: false,
            timetable: [],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "sat", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Sunday schedule configuration",
        type: DaySchedule,
        example: {
            isOperative: false,
            timetable: [],
        },
    }),
    __metadata("design:type", DaySchedule)
], DisplaySchedule.prototype, "sun", void 0);
